module.exports = __webpack_public_path__ + "img/vuelogo.66f2edcb.png";